<div class="modal-header">
  <h4 class="modal-title">{{'chooseFinalizationAction.title' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset>
    <p>{{'chooseFinalizationAction.explanationText.text' | translate}}</p>
    <div class="ps-5">
      <div class="form-check">
        <input class="form-check-input" type="radio" name="gridRadios" id="finalizeProjectCB" value="{{SELECTED_ACTION_FINALIZE_PROJECT}}" [(ngModel)]="selectedAction">
        <label class="form-check-label" for="finalizeProjectCB">{{'chooseFinalizationAction.selection.finalize' | translate}}</label>
      </div>

      <div class="form-check mt-3">
        <input class="form-check-input" type="radio" name="gridRadios" id="finalizeLegacyProjectCB" value="{{SELECTED_ACTION_FINALIZE_LEGACY_PROJECT}}" [(ngModel)]="selectedAction" [disabled]="!isLegacyOptionAvailable">
        <label class="form-check-label" for="finalizeLegacyProjectCB">{{'chooseFinalizationAction.selection.finalizeLegacyProject' | translate}}</label>
      </div>

      @if(showExportWithoutPdm) {
        <div class="form-check mt-3">
          <input class="form-check-input" type="radio" name="gridRadios" id="setToClosedCB" value="{{SELECTED_ACTION_SET_TO_CLOSED}}" [(ngModel)]="selectedAction">
          <label class="form-check-label" for="setToClosedCB">{{'chooseFinalizationAction.selection.setToClosed' | translate}}</label>
        </div>
      }

      <div style="min-height: 5px;"></div>

      @if (!isLocked) {
        <div class="form-check mt-3">
          <input class="form-check-input" type="radio" name="gridRadios" id="setToLockedCB" value="{{SELECTED_ACTION_SET_TO_LOCKED}}" [(ngModel)]="selectedAction">
          <label class="form-check-label" for="setToLockedCB">{{'chooseFinalizationAction.selection.setToLocked' | translate}}</label>
        </div>
      }

      @if (isLocked) {
        <div class="form-check mt-3">
          <input class="form-check-input" type="radio" name="gridRadios" id="setToUnlockedCB" value="{{SELECTED_ACTION_SET_TO_UNLOCKED}}" [(ngModel)]="selectedAction">
          <label class="form-check-label" for="setToUnlockedCB">{{'chooseFinalizationAction.selection.setToUnlocked' | translate}}</label>
        </div>
      }

      @if (canGeneratePdmArticleNumber()) {
        <div class="form-check mt-3">
          <input class="form-check-input" type="radio" name="gridRadios" id="generateMcsgdsArticleNoLong" value="{{SELECTED_ACTION_GENERATE_PDM_ARTICLE_NUMBER}}" [(ngModel)]="selectedAction">
          <label class="form-check-label" for="generateMcsgdsArticleNoLong">{{'chooseFinalizationAction.selection.generate.mcsgds.articleNo' | translate}}</label>
        </div>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button class="btn btn-primary btn-forward" (click)="nextButtonClickHandler()" [disabled]="!selectedAction">{{'global.label.next' | translate}}</button>
</div>
